import React from "react";
import { useLocation, Link } from "react-router-dom";

function NoAccessPage() {
  const query = new URLSearchParams(useLocation().search);
  const reason = query.get("reason");

  return (
    <div className="min-h-screen flex items-center justify-center  via-purple-100 to-pink-100 px-4 py-8">
      <div className="bg-white shadow-2xl rounded-3xl p-8 sm:p-12 max-w-md w-full text-center transform transition-all duration-300 hover:scale-105 animate-fade-in">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-red-600 mb-6 tracking-tight">
          Access Denied
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl mb-4 leading-relaxed">
          You don’t have permission to access this application.
        </p>
        {reason && (
          <p className="text-gray-500 text-sm italic mb-4">
            Reason: {reason}
          </p>
        )}
        <p className="text-gray-600 text-base sm:text-lg mb-6">
          Please contact your{" "}
          <span className="font-semibold text-blue-600">Admin Team</span> for assistance.
        </p>
        <p className="text-gray-600 text-base sm:text-lg mb-8">
          Or submit a ticket via the{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 font-semibold underline hover:text-blue-800 transition-colors duration-200"
            href="https://helpathome.go2connect.com/"
          >
            IT Service Portal
          </a>
          .
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 transform hover:-translate-y-1"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}

export default NoAccessPage;